import React from "react";

const positions = [
  {
    id: 1,
    title: "Frontend Developer",
    category: "Engineering",
    type: "Full-Time",
    location: "Remote",
  },
  {
    id: 2,
    title: "UI/UX Designer",
    category: "Design",
    type: "Part-Time",
    location: "New York, USA",
  },
  {
    id: 3,
    title: "Backend Developer",
    category: "Engineering",
    type: "Full-Time",
    location: "San Francisco, USA",
  },
  {
    id: 4,
    title: "Product Manager",
    category: "Product",
    type: "Contract",
    location: "Remote",
  },
];

const OpenPosition = ({ scrollToApplyForm }) => {
  return (
    <>
      <section className="max-w-7xl mx-auto py-12 md:py-10 px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-[#0F172A] font-amiriQuran relative inline-block">
            <span className="relative">
              Current Opening
              <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-[#0e4322] to-[#3a5630]"></span>
            </span>
          </h1>
          <p className="mt-6 text-xl text-[#1F2937] max-w-3xl mx-auto">
            Explore exciting career opportunities at NextEra Research and join our team of innovators.
          </p>
        </div>

        {/* Single Position - Enhanced Design */}
        <div className="max-w-4xl mx-auto">
          <div className="group relative bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-100 hover:shadow-3xl transition-all duration-300 transform hover:-translate-y-1">
            {/* Position Header with Gradient */}
            <div className="bg-gradient-to-r from-[#0e4322] to-[#3a5630] p-6 text-white">
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="text-3xl font-bold font-amiriQuran">Business Development Manager</h2>
                </div>
              </div>
            </div>

            <div className="p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                <div>
                  <h3 className="text-xl font-bold text-[#0F172A] mb-4 border-b pb-2 border-[#e0f2e9]">Key Responsibilities</h3>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <span className="inline-block w-2 h-2 bg-[#3a5630] rounded-full mt-2 mr-3"></span>
                      <span>Timely Follow Up.</span>
                    </li>
                    <li className="flex items-start">
                      <span className="inline-block w-2 h-2 bg-[#3a5630] rounded-full mt-2 mr-3"></span>
                      <span>Interacting with customers telephonically & Via Chat.</span>
                    </li>
                    <li className="flex items-start">
                      <span className="inline-block w-2 h-2 bg-[#3a5630] rounded-full mt-2 mr-3"></span>
                      <span>Sharing updates on product & services of NextEra Research.</span>
                    </li>
                    <li className="flex items-start">
                      <span className="inline-block w-2 h-2 bg-[#3a5630] rounded-full mt-2 mr-3"></span>
                      <span>Convincing prospects to opt for our research-based services.</span>
                    </li>
                    <li className="flex items-start">
                      <span className="inline-block w-2 h-2 bg-[#3a5630] rounded-full mt-2 mr-3"></span>
                      <span>Sharing the research reports of NextEra Research with the clients.</span>
                    </li>
                    <li className="flex items-start">
                      <span className="inline-block w-2 h-2 bg-[#3a5630] rounded-full mt-2 mr-3"></span>
                      <span>Revenue generation through Services selling. </span>
                    </li>
                    <li className="flex items-start">
                      <span className="inline-block w-2 h-2 bg-[#3a5630] rounded-full mt-2 mr-3"></span>
                      <span>Ability to be on the phone for a long time.</span>
                    </li>
                    <li className="flex items-start">
                      <span className="inline-block w-2 h-2 bg-[#3a5630] rounded-full mt-2 mr-3"></span>
                      <span>Manage inbound and outbound customer calls promptly. </span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-[#0F172A] mb-4 border-b pb-2 border-[#e0f2e9]">Requirements</h3>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <span className="inline-block w-2 h-2 bg-[#3a5630] rounded-full mt-2 mr-3"></span>
                      <span>MBA degree in any discipline</span>
                    </li>
                    <li className="flex items-start">
                      <span className="inline-block w-2 h-2 bg-[#3a5630] rounded-full mt-2 mr-3"></span>
                      <span>Excellent verbal and written communication skills</span>
                    </li>
                    <li className="flex items-start">
                      <span className="inline-block w-2 h-2 bg-[#3a5630] rounded-full mt-2 mr-3"></span>
                      <span>Basic understanding of financial markets and products</span>
                    </li>
                    <li className="flex items-start">
                      <span className="inline-block w-2 h-2 bg-[#3a5630] rounded-full mt-2 mr-3"></span>
                      <span>Fluency in both English and Hindi</span>
                    </li>
                    <li className="flex items-start">
                      <span className="inline-block w-2 h-2 bg-[#3a5630] rounded-full mt-2 mr-3"></span>
                      <span>Ability to handle long phone hours and join immediately</span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Enhanced Apply Button */}
              <div className="text-center mt-10">
                <button
                  onClick={scrollToApplyForm}
                  className="relative inline-flex items-center justify-center px-8 py-4 overflow-hidden font-bold text-white rounded-xl group"
                >
                  <span className="absolute inset-0 w-full h-full transition-all duration-300 ease-out bg-gradient-to-r from-[#0e4322] to-[#3a5630] group-hover:from-[#175f33] group-hover:to-[#1e7e34]"></span>
                  <span className="absolute shadow-xl shadow-[#0e4322]/50 inset-0 w-full h-full border border-white rounded-xl opacity-0 group-hover:opacity-30"></span>
                  <span className="absolute w-0 h-0 transition-all duration-300 ease-out bg-white rounded-full group-hover:w-56 group-hover:h-56 opacity-5"></span>
                  <span className="relative flex items-center text-lg">
                    Apply Now
                    <svg className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Optional CTA */}
        <div className="mt-16 text-center">
          <p className="text-xl text-[#1F2937] mb-6">
            Don't see your perfect role? We're always looking for talented individuals.
          </p>
        </div>
      </section>
    </ >
  );
};

export default OpenPosition;
